module.exports = __webpack_public_path__ + "static/1-54ac8ecd1e86f1b7ff0c4c47664d9eb0.jpg";